import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { getApiData } from "../../../services/index";

const Youtube = () => {
  const [testimonials, setTestimonials] = useState([]);

  const checkData = () => {
    console.log("checkData");
    const app = {};
    getApiData("api/get_testimonials", app).then((result) => {
      console.log("result: ", result);
      if (result && result["status"] === 200) {
        setTestimonials(result["data"]);
      }
    });
  };

  useEffect(() => {
    checkData();
  }, []);

  // Function to extract Video ID
  const getYoutubeVideoId = (url) => {
    let videoId = null;

    // Handle YouTube Shorts URL
    if (url.includes("youtube.com/shorts/")) {
      videoId = url.split("/shorts/")[1];
    }
    // Handle Regular YouTube Video URL
    else if (url.includes("youtube.com/watch?v=")) {
      videoId = url.split("v=")[1];
      const ampersandPosition = videoId.indexOf("&");
      if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
      }
    }
    // Handle youtu.be Short URL
    else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1];
    }

    return videoId;
  };

  return (
    <>
      <section className="section color-bottom">
        <div className="container">
          <div className="max-w more">
            <div
              data-w-id="166d813f-4ff4-c949-5b3d-e38231847ba1"
              className="flex-tag"
            >
              <div className="bullet-tag "></div>
              <h2 className="main-title text-white">Student Testimonials</h2>
            </div>
            <p
              data-w-id="166d813f-4ff4-c949-5b3d-e38231847ba5"
              className="subhead-main for-title white"
            >
              <span className="color-text">
                Hear what our successful students have to say about{" "}
              </span>
              <span className="gray-text-color">
                <strong className="bold-text-2">Win Migration Group.</strong>
              </span>
            </p>
          </div>
          <div className="margin-20px">
            <Swiper
              spaceBetween={15}
              slidesPerView={1}
              breakpoints={{
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              pagination={{
                clickable: true,
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Pagination, Autoplay]}
              loop={true}
            >
              {testimonials
                .filter((item) => item.type === "youtube")
                .map((item, index) => {
                  const videoId = getYoutubeVideoId(item.media);
                  return (
                    <SwiperSlide key={index}>
                      <div className="video-container">
                        <iframe
                          width="360"
                          height="315"
                          src={`https://www.youtube.com/embed/${videoId}`}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Youtube;
